import { useEffect } from 'react'

import { useAuthUser } from '~/hooks/useAuthUser'
import { useIsSplitsConnectInstalled } from '~/hooks/useIsSplitsConnectInstalled'
import { useUserFlag } from '~/hooks/useUserFlag'
import { UserFlagKey } from '~/types'
import { setTrackingUserProperties } from '~/utils/tracking'

export const useSplitsConnectTracking = () => {
  const isInstalled = useIsSplitsConnectInstalled()
  const { user } = useAuthUser()
  const userId = user?.id
  const setUserFlag = useUserFlag()

  // eslint-disable-next-line local/noUseEffect -- mirroring browser capability changes into analytics is synchronization an effect must do
  useEffect(() => {
    setTrackingUserProperties({ splitsConnectInstalled: isInstalled })
    if (userId && isInstalled) {
      const storageKey = `${UserFlagKey.SPLITS_CONNECT_DETECTED}:${userId}`
      if (sessionStorage.getItem(storageKey)) return

      sessionStorage.setItem(storageKey, 'true')
      void setUserFlag(UserFlagKey.SPLITS_CONNECT_DETECTED)
    }
  }, [isInstalled, setUserFlag, userId])
}
